// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__-VVF9","cabinet":"Layout_cabinet__dDjFs","cabinet__wrapper":"Layout_cabinet__wrapper__sMIVI"};